module.exports = __webpack_public_path__ + "static/media/discussion.09fac04b.svg";